import { Expose } from 'class-transformer'
import { QuotePolitician } from '../../entity'

export class ListQuotePoliticiansDTO {

    @Expose()
    quotePoliticians!: QuotePolitician[]

}
